import script from "./PatientBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientBar.vue?vue&type=script&setup=true&lang=js"

import "./PatientBar.vue?vue&type=style&index=0&id=7740e7da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7740e7da"]])

export default __exports__